export const mapProduct = (product) => {
  if (!product) return product;

  // Normalize Laravel model to React component expectations
  const normalizedProduct = {
    ...product,
    title: product.name || product.title,
    // handle nested category from Laravel relationship
    category: typeof product.category === 'object' && product.category ? product.category.name : product.category,
    // Laravel might return just path, prepend base url if needed, assuming AWS_URL/local URL is handled by backend or relative here
    image: product.image 
           ? (product.image.startsWith('http') ? product.image : `${process.env.REACT_APP_BACKEND_URL || "https://apistore.iqbaldeveloper.my.id"}/storage/${product.image}`)
           : "https://via.placeholder.com/600",
    rating: {
      rate: product.reviews?.length > 0 ? (product.reviews.reduce((acc, r) => acc + r.rating, 0) / product.reviews.length) : 0,
      count: product.reviews?.length || 0,
    },
    // Adding newly integrated fields
    product_type: product.product_type || 'physical', // fallback to physical
    final_price: product.final_price !== undefined ? product.final_price : product.price,
    active_flash_sale: product.active_flash_sale || null,
  };

  return normalizedProduct;
};
